import React from 'react';
import './index.scss';
const DineinTheatreHeader = ({}) => {
  return <div className="dinein-theatre-container">DINE IN - THEATRE</div>;
};

export default DineinTheatreHeader;
